import { useEffect } from "react";
import { useApi, createApiHook } from "../utils/apiUtils";

const useFetchQuestionnaireFormData = () => {
  const { apiGet } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  useEffect(() => {
    const fetchData = async () => {
      startLoading();
      const response = await apiGet("/questionnaires/questionnaire_types", "Error al obtener los tipos de cuestionario");
      setResponse(response);
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { data, error, loading };
};

export default useFetchQuestionnaireFormData;
